import { EraserIcon } from '@diligentcorp/atlas-react-icons';
import { Button, ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function ClearButton(props: ButtonProps) {
  const { children, ...rest } = props;
  const { t } = useTranslation(['common']);
  return (
    <Button {...rest} startIcon={<EraserIcon />}>
      {children || t('common:form.clear')}
    </Button>
  );
}
